import React from 'react';
import { TextField, MenuItem } from '@material-ui/core';
import { useKeyRewardProgramCollection } from 'queries/Car';
import { useTranslations } from 'components/utilities';
import useStyles from '../../styles';
import { useSelector, useDispatch } from 'react-redux';
import { setRewardOptions } from 'store/actions';
import { carDetailSelectors } from 'store/selectors';

const KeyRewardProgram = () => {
	const { data, isFetched } = useKeyRewardProgramCollection();
	const { i18n, t } = useTranslations();
	const { select } = useStyles();
	const language = i18n.language;
	const dispatch = useDispatch();
	const rewardOptions = useSelector(carDetailSelectors.getRewardOptions);

	const handleChange = (e) => {
		setRewardOptions(e.target.value)(dispatch);
	};

	if (!isFetched) return null;

	if (rewardOptions === null) {
		setRewardOptions(data[0].key)(dispatch);
	}

	return (
		<TextField
			select
			variant="outlined"
			size="small"
			color="primary"
			label={t('car.key_reward_program_placeholder')}
			className={select}
			value={!rewardOptions ? data[0].key : rewardOptions[0]}
			onChange={handleChange}
			fullWidth
		>
			{data.map(({ key, label }) => (
				<MenuItem key={key} value={key}>
					{label[language]}
				</MenuItem>
			))}
		</TextField>
	);
};

export default KeyRewardProgram;
